<app-selector
  label="Stick Cricket Game"
  [isEmptySelectable]="isEmptySelectable"
  [data]="stickCricketGameCoreService.stickCricketGameList$ | async"
  displayKey="name"
  [formControl]="ctrl"
  (refreshEvent)="refresh()"
  hintStyle="margin-left: -14px; margin-top: -5px"
  [loading]="stickCricketGameCoreService.loading$ | async"
  [hint]="hint"
>
</app-selector>
